import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import LoaderComponent from "../../../libraries/loader/loader";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import excelIcon from '../../../assets/images/excel.png';
import {
  Fetchexecutequery,Fetchupdatequery,
  Fetchetlupload,
} from "../../../services/process/BRS1/brsService7";
import * as XLSX from 'xlsx';

const REPORT_OPTIONS = [
  { label: "IRN Report",     value: "irn_report",     table: "irn_report" },
  { label: "Sales Register", value: "sales_register", table: null },
];

const SALES_SHEETS = [
  { label: "Tax Invoice",  value: "tax_invoice",  table: "tax_invoice" },
  { label: "Credit Note",  value: "credit_note",  table: "credit_note" },
  { label: "Debit Note",   value: "debit_note",   table: "debit_note" },
];

const FILE_UPLOAD_PATH = "/uploads/irn/";

function IrnUpload() {
  const [rowData, setRowData]               = useState([]);
  const [columnDefs, setColumnDefs]         = useState([]);
  const [loading, setLoading]               = useState(true);
  const [error, setError]                   = useState(null);
  const [successMsg, setSuccessMsg]         = useState("");
  const [selectedMonth, setSelectedMonth]   = useState("");
  const [closeMonth, setCloseMonth]         = useState("");
  const [selectedReport, setSelectedReport] = useState("");
  const [fileUploads, setFileUploads]       = useState({});
  const [fileInputKey, setFileInputKey]     = useState(0);
  const [activeTab, setActiveTab]           = useState(0);
  const [activeSheetTab, setActiveSheetTab] = useState(0);
  const [downloadData, setDownloadData]     = useState([]);
  const [downloadColumns, setDownloadColumns] = useState([]);
  const [downloadMonth, setDownloadMonth]   = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [uploadLoading, setUploadLoading]   = useState(false);
  const [closeLoading, setCloseLoading]     = useState(false);
  const [exportLoading, setExportLoading]   = useState(false);
  const [closeMsg, setCloseMsg]             = useState("");
  const [salesRegisterData, setSalesRegisterData] = useState({});
  const [salesRegisterColumns, setSalesRegisterColumns] = useState({});

  const fileInputRef = useRef(null);

  const [userCredentials] = useState(
    JSON.parse(sessionStorage.getItem("userCredentials"))
  );

  const formatColumnName = (name) =>
    name.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  const getFormattedDate = () =>
    new Date().toISOString().slice(0, 19).replace("T", " ");

  // ── File select → upload to server ───────────────────────────────────────
  const handleFileUpload = async (e, columnName, file_path) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("filePath", file_path);

    setUploadLoading(true);
    try {
      const response = await fetch(
        "http://154.61.75.209:1200/api/v2/user_modules/upload/",
        { method: "POST", body: formData }
      );

      if (response.ok) {
        const data = await response.json();
        setFileUploads((prev) => ({
          ...prev,
          [columnName]: {
            fileName: data.Filename,
            filePath: data.Filepath,
          },
        }));
        console.log("File uploaded successfully:", data.Filepath, data.Filename);
      } else {
        const errorData = await response.json();
        setError("File upload failed: " + (errorData.Message || "Unknown error"));
      }
    } catch (err) {
      console.error("Error uploading file:", err);
      setError("File upload failed.");
    } finally {
      setUploadLoading(false);
    }
  };

  // ── Reset all fields ──────────────────────────────────────────────────────
  const resetForm = () => {
    setFileUploads({});
    setSelectedMonth("");
    setCloseMonth("");
    setSelectedReport("");
    setFileInputKey((prev) => prev + 1);
  };

  // ── Fetch history grid ────────────────────────────────────────────────────
  const fetchHistory = async () => {
    const payload = {
      query: `SELECT 
        IFNULL(TRIM(file_name), '') AS file_name,
        IFNULL(CONVERT(file_size, CHAR), '0') AS file_size_bytes,
        IFNULL(TRIM(status), '') AS status,
        IFNULL(TRIM(comments), '') AS comments,file_row_count as \`row count\`,
        DATE_FORMAT(uploaded_time, '%d-%m-%Y %H:%i:%s') AS created_on
      FROM process_data.file_uploads
      WHERE process_id = 36
        AND is_active = 1 
        AND entities_id = ${userCredentials.selectedentity}
      ORDER BY file_uploads_id DESC 
      LIMIT 30`,
    };
    try {
      const creds = Fetchexecutequery();
      const res   = await axios.post(creds[1], payload, creds[0]);
      if (res.data?.length) {
        const cols = Object.keys(res.data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field:      key,
          sortable:   true,
          filter:     true,
        }));
        setColumnDefs(cols);
        setRowData(res.data);
      }
    } catch (err) {
      console.error(err);
      setError("Error fetching history");
    }
  };

  // ── Fetch download data ───────────────────────────────────────────────────
  const fetchSalesRegisterData = async (month = "") => {
    setDownloadLoading(true);
    const monthFilter = month ? `AND ti.month = '${month}'` : "";

    const sheetsData = {};
    const sheetsColumns = {};

    try {
      // Tax Invoice Query
      const taxInvoiceQuery = `
        SELECT 
          ti.*,
          CASE 
            WHEN IFNULL(ti.is_closed, 0) = 1 THEN 'yes' 
            ELSE 'no' 
          END AS close_status,
          
          /* ================= IRN FIELDS ================= */
          irn.\`Seller State Code\`        AS irn_from_state,
          irn.\`Buyer State Code\`         AS irn_to_state,
          irn.\`Buyer GSTIN\`              AS irn_gst,
          irn.\`Total Assessable Value\`   AS irn_taxable,
          irn.\`Total CGST Value\`         AS irn_cgst,
          irn.\`Total SGST Value\`         AS irn_sgst,
          irn.\`Total IGST Value\`         AS irn_igst,
          irn.\`Total Invoice Value\`      AS irn_total,
          irn.\`Item HSN Code\`            AS irn_hsn,
          irn.\`Supply Type\`              AS irn_supply_type,
          irn.\`Document Type\`            AS irn_doc_type,
          DATE_FORMAT(STR_TO_DATE(irn.\`Document Date\`, '%d-%m-%Y'), '%d-%m-%Y') AS irn_date,

          /* ================= VALIDATIONS ================= */
          CASE 
            WHEN ti.\`from state code\` = irn.\`Seller State Code\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_from_state,
          
          CASE 
            WHEN ti.\`to state code\` = irn.\`Buyer State Code\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_to_state,
          
          CASE 
            WHEN TRIM(ti.\`client gst no\`) = TRIM(irn.\`Buyer GSTIN\`) THEN 'TRUE' ELSE 'FALSE' 
          END AS val_gst,
          
          (IFNULL(irn.\`Total Assessable Value\`,0) - IFNULL(ti.\`taxable\`,0)) AS diff_taxable,
          (IFNULL(irn.\`Total CGST Value\`,0) - IFNULL(ti.\`cgst\`,0)) AS diff_cgst,
          (IFNULL(irn.\`Total SGST Value\`,0) - IFNULL(ti.\`sgst/ugst\`,0)) AS diff_sgst,
          (IFNULL(irn.\`Total IGST Value\`,0) - IFNULL(ti.\`igst\`,0)) AS diff_igst,
          (IFNULL(irn.\`Total Invoice Value\`,0) - IFNULL(ti.\`invoice total\`,0)) AS diff_total,
          
          CASE 
            WHEN ti.\`hsn/sac code\` = irn.\`Item HSN Code\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_hsn,
          
          CASE 
            WHEN ti.\`supply type code\` = irn.\`Supply Type\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_supply_type,
          
          CASE 
            WHEN ti.\`document_type\` = irn.\`Document Type\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_doc_type,
          
          CASE 
            WHEN DATE_FORMAT(ti.\`invoice date\`, '%d-%m-%Y') = DATE_FORMAT(STR_TO_DATE(irn.\`Document Date\`, '%d-%m-%Y'), '%d-%m-%Y') 
            THEN 'TRUE' ELSE 'FALSE' 
          END AS val_date

        FROM irn.tax_invoice ti
        LEFT JOIN irn.irn_report irn
          ON TRIM(ti.\`invoice #\`) = TRIM(irn.\`Document Number\`)
        WHERE ti.is_active = 1 ${monthFilter}
        ORDER BY ti.created_on DESC
      `;

      // Credit Note Query
      const creditNoteQuery = `
        SELECT 
          cn.*,
          CASE 
            WHEN IFNULL(cn.is_closed, 0) = 1 THEN 'yes' 
            ELSE 'no' 
          END AS close_status,
          
          /* ================= IRN FIELDS ================= */
          irn.\`Seller State Code\`        AS irn_from_state,
          irn.\`Buyer State Code\`         AS irn_to_state,
          irn.\`Buyer GSTIN\`              AS irn_gst,
          irn.\`Total Assessable Value\`   AS irn_taxable,
          irn.\`Total CGST Value\`         AS irn_cgst,
          irn.\`Total SGST Value\`         AS irn_sgst,
          irn.\`Total IGST Value\`         AS irn_igst,
          irn.\`Total Invoice Value\`      AS irn_total,
          irn.\`Item HSN Code\`            AS irn_hsn,
          irn.\`Supply Type\`              AS irn_supply_type,
          irn.\`Document Type\`            AS irn_doc_type,
          DATE_FORMAT(STR_TO_DATE(irn.\`Document Date\`, '%d-%m-%Y'), '%d-%m-%Y') AS irn_date,

          /* ================= VALIDATIONS ================= */
          CASE 
            WHEN cn.\`from state code\` = irn.\`Seller State Code\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_from_state,
          
          CASE 
            WHEN cn.\`to state code\` = irn.\`Buyer State Code\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_to_state,
          
          CASE 
            WHEN TRIM(cn.\`client gst no\`) = TRIM(irn.\`Buyer GSTIN\`) THEN 'TRUE' ELSE 'FALSE' 
          END AS val_gst,
          
          (IFNULL(irn.\`Total Assessable Value\`,0) - IFNULL(cn.\`taxable\`,0)) AS diff_taxable,
          (IFNULL(irn.\`Total CGST Value\`,0) - IFNULL(cn.\`cgst\`,0)) AS diff_cgst,
          (IFNULL(irn.\`Total SGST Value\`,0) - IFNULL(cn.\`sgst/ugst\`,0)) AS diff_sgst,
          (IFNULL(irn.\`Total IGST Value\`,0) - IFNULL(cn.\`igst\`,0)) AS diff_igst,
          (IFNULL(irn.\`Total Invoice Value\`,0) - IFNULL(cn.\`invoice total\`,0)) AS diff_total,
          
          CASE 
            WHEN cn.\`hsn/sac code\` = irn.\`Item HSN Code\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_hsn,
          
          CASE 
            WHEN cn.\`supply type code\` = irn.\`Supply Type\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_supply_type,
          
          CASE 
            WHEN cn.\`invoice type\` = irn.\`Document Type\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_doc_type,
          
          CASE 
            WHEN DATE_FORMAT(cn.\`credit note date\`, '%d-%m-%Y') = DATE_FORMAT(STR_TO_DATE(irn.\`Document Date\`, '%d-%m-%Y'), '%d-%m-%Y') 
            THEN 'TRUE' ELSE 'FALSE' 
          END AS val_date

        FROM irn.credit_note cn
        LEFT JOIN irn.irn_report irn
          ON TRIM(cn.\`credit note no\`) = TRIM(irn.\`Document Number\`)
        WHERE cn.is_active = 1 ${monthFilter}
        ORDER BY cn.created_on DESC
      `;

      // Debit Note Query
      const debitNoteQuery = `
        SELECT 
          dn.*,
          CASE 
            WHEN IFNULL(dn.is_closed, 0) = 1 THEN 'yes' 
            ELSE 'no' 
          END AS close_status,
          
          /* ================= IRN FIELDS ================= */
          irn.\`Seller State Code\`        AS irn_from_state,
          irn.\`Buyer State Code\`         AS irn_to_state,
          irn.\`Buyer GSTIN\`              AS irn_gst,
          irn.\`Total Assessable Value\`   AS irn_taxable,
          irn.\`Total CGST Value\`         AS irn_cgst,
          irn.\`Total SGST Value\`         AS irn_sgst,
          irn.\`Total IGST Value\`         AS irn_igst,
          irn.\`Total Invoice Value\`      AS irn_total,
          irn.\`Item HSN Code\`            AS irn_hsn,
          irn.\`Supply Type\`              AS irn_supply_type,
          irn.\`Document Type\`            AS irn_doc_type,
          DATE_FORMAT(STR_TO_DATE(irn.\`Document Date\`, '%d-%m-%Y'), '%d-%m-%Y') AS irn_date,

          /* ================= VALIDATIONS ================= */
          CASE 
            WHEN dn.\`Invoice From State\` = irn.\`Seller State Code\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_from_state,
          
          CASE 
            WHEN dn.\`Invoice To State\` = irn.\`Buyer State Code\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_to_state,
          
          CASE 
            WHEN TRIM(dn.\`Client_GST_No\`) = TRIM(irn.\`Buyer GSTIN\`) THEN 'TRUE' ELSE 'FALSE' 
          END AS val_gst,
          
          (IFNULL(irn.\`Total Assessable Value\`,0) - IFNULL(dn.\`Taxable\`,0)) AS diff_taxable,
          (IFNULL(irn.\`Total CGST Value\`,0) - IFNULL(dn.\`CGST@9%\`,0)) AS diff_cgst,
          (IFNULL(irn.\`Total SGST Value\`,0) - IFNULL(dn.\`SGST/UTGST@9%\`,0)) AS diff_sgst,
          (IFNULL(irn.\`Total IGST Value\`,0) - IFNULL(dn.\`IGST@18%\`,0)) AS diff_igst,
          (IFNULL(irn.\`Total Invoice Value\`,0) - IFNULL(dn.\`Debit Note Total\`,0)) AS diff_total,
          
          CASE 
            WHEN dn.\`HSN_Code\` = irn.\`Item HSN Code\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_hsn,
          
          CASE 
            WHEN dn.\`supply_type_code\` = irn.\`Supply Type\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_supply_type,
          
          CASE 
            WHEN dn.\`invoice_type\` = irn.\`Document Type\` THEN 'TRUE' ELSE 'FALSE' 
          END AS val_doc_type,
          
          CASE 
            WHEN DATE_FORMAT(dn.\`Date\`, '%d-%m-%Y') = DATE_FORMAT(STR_TO_DATE(irn.\`Document Date\`, '%d-%m-%Y'), '%d-%m-%Y') 
            THEN 'TRUE' ELSE 'FALSE' 
          END AS val_date

        FROM irn.debit_note dn
        LEFT JOIN irn.irn_report irn
          ON TRIM(dn.\`Debit Note #\`) = TRIM(irn.\`Document Number\`)
        WHERE dn.is_active = 1 ${monthFilter}
        ORDER BY dn.created_on DESC
      `;

      const queries = [
        { key: "tax_invoice", query: taxInvoiceQuery },
        { key: "credit_note", query: creditNoteQuery },
        { key: "debit_note", query: debitNoteQuery },
      ];

      for (const { key, query } of queries) {
        const payload = { query };
        const creds = Fetchexecutequery();
        const res = await axios.post(creds[1], payload, creds[0]);

        if (res.data && res.data.length > 0) {
          const cols = Object.keys(res.data[0]).map((key) => ({
            headerName: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
            field: key,
            sortable: true,
            filter: true,
          }));
          sheetsData[key] = res.data;
          sheetsColumns[key] = cols;
        } else {
          sheetsData[key] = [];
          sheetsColumns[key] = [];
        }
      }

      setSalesRegisterData(sheetsData);
      setSalesRegisterColumns(sheetsColumns);
    } catch (err) {
      console.error("Sales Register fetch error:", err);
      setError("Error fetching sales register data");
    } finally {
      setDownloadLoading(false);
    }
  };

  const fetchDownloadData = async (month = "", reportType = selectedReport) => {
    if (reportType === "sales_register") {
      await fetchSalesRegisterData(month);
      return;
    }

    setDownloadLoading(true);

    const monthFilter = month
      ? `AND irn.month = '${month}'`
      : "";

    const payload = {
      query: `
        SELECT 
            base.*,

            /* ================= VALIDATIONS ================= */

            /* TEXT */
            CASE 
                WHEN base.irn_from_state = base.src_from_state THEN 'TRUE' ELSE 'FALSE' 
            END AS val_from_state,

            CASE 
                WHEN base.irn_to_state = base.src_to_state THEN 'TRUE' ELSE 'FALSE' 
            END AS val_to_state,

            CASE 
                WHEN TRIM(base.irn_gst) = TRIM(base.src_gst) THEN 'TRUE' ELSE 'FALSE' 
            END AS val_gst,

            /* NUMERIC */
            (IFNULL(base.irn_taxable,0) - IFNULL(base.src_taxable,0)) AS diff_taxable,
            (IFNULL(base.irn_cgst,0) - IFNULL(base.src_cgst,0)) AS diff_cgst,
            (IFNULL(base.irn_sgst,0) - IFNULL(base.src_sgst,0)) AS diff_sgst,
            (IFNULL(base.irn_igst,0) - IFNULL(base.src_igst,0)) AS diff_igst,
            (IFNULL(base.irn_total,0) - IFNULL(base.src_total,0)) AS diff_total,

            /* TEXT */
            CASE 
                WHEN base.irn_hsn = base.src_hsn THEN 'TRUE' ELSE 'FALSE' 
            END AS val_hsn,

            CASE 
                WHEN base.irn_supply_type = base.src_supply_type THEN 'TRUE' ELSE 'FALSE' 
            END AS val_supply_type,

            CASE 
                WHEN base.irn_doc_type = base.src_doc_type THEN 'TRUE' ELSE 'FALSE' 
            END AS val_doc_type,

            /* DATE */
            CASE 
                WHEN base.irn_date = base.src_date THEN 'TRUE' ELSE 'FALSE' 
            END AS val_date

        FROM (

            SELECT 
                irn.\`Document Number\`,

                /* IRN */
                irn.\`Seller State Code\`        AS irn_from_state,
                irn.\`Buyer State Code\`         AS irn_to_state,
                irn.\`Buyer GSTIN\`              AS irn_gst,
                irn.\`Total Assessable Value\`   AS irn_taxable,
                irn.\`Total CGST Value\`         AS irn_cgst,
                irn.\`Total SGST Value\`         AS irn_sgst,
                irn.\`Total IGST Value\`         AS irn_igst,
                irn.\`Total Invoice Value\`      AS irn_total,
                irn.\`Item HSN Code\`            AS irn_hsn,
                irn.\`Supply Type\`              AS irn_supply_type,
                irn.\`Document Type\`            AS irn_doc_type,
                DATE_FORMAT(
                    STR_TO_DATE(irn.\`Document Date\`, '%d-%m-%Y'),
                    '%d-%m-%Y'
                ) AS irn_date,

                /* SOURCE */
                COALESCE(ti.\`from state code\`, cn.\`from state code\`, dn.\`Invoice From State\`) AS src_from_state,
                COALESCE(ti.\`to state code\`, cn.\`to state code\`, dn.\`Invoice To State\`) AS src_to_state,
                COALESCE(ti.\`client gst no\`, cn.\`client gst no\`, dn.\`Client_GST_No\`) AS src_gst,

                COALESCE(ti.\`taxable\`, cn.\`taxable\`*-1, dn.\`Taxable\`) AS src_taxable,
                COALESCE(ti.\`cgst\`, cn.\`cgst\`*-1, dn.\`CGST@9%\`) AS src_cgst,
                COALESCE(ti.\`sgst/ugst\`, cn.\`sgst/ugst\`*-1, dn.\`SGST/UTGST@9%\`) AS src_sgst,
                COALESCE(ti.\`igst\`, cn.\`igst\`*-1, dn.\`IGST@18%\`) AS src_igst,

                COALESCE(ti.\`invoice total\`, cn.\`invoice total\`*-1, dn.\`Debit Note Total\`) AS src_total,
                COALESCE(ti.\`hsn/sac code\`, cn.\`hsn/sac code\`, dn.\`HSN_Code\`) AS src_hsn,
                COALESCE(ti.\`supply type code\`, cn.\`supply type code\`, dn.\`supply_type_code\`) AS src_supply_type,
                COALESCE(ti.\`document_type\`, cn.\`invoice type\`, dn.\`invoice_type\`) AS src_doc_type,
                DATE_FORMAT(
                    COALESCE(ti.\`invoice date\`, cn.\`credit note date\`, dn.\`Date\`),
                    '%d-%m-%Y'
                ) AS src_date

            FROM irn.irn_report irn

            LEFT JOIN irn.tax_invoice ti
                ON TRIM(irn.\`Document Number\`) = TRIM(ti.\`invoice #\`)

            LEFT JOIN irn.credit_note cn
                ON TRIM(irn.\`Document Number\`) = TRIM(cn.\`credit note no\`)

            LEFT JOIN irn.debit_note dn
                ON TRIM(irn.\`Document Number\`) = TRIM(dn.\`Debit Note #\`)

            WHERE 1=1
            AND irn.is_active = 1
            ${monthFilter}

        ) base;
      `,
    };

    try {
      const creds = Fetchexecutequery();

      const res = await axios.post(
        creds[1],
        payload,
        creds[0]
      );

      const data = res.data;

      if (data && data.length > 0) {
        const cols = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
          sortable: true,
          filter: true,
        }));

        setDownloadColumns(cols);
        setDownloadData(data);
      } else {
        setDownloadData([]);
        setDownloadColumns([]);

        if (month) {
          setError("No completed reports found for the selected month");
          setTimeout(() => setError(""), 4000);
        }
      }
    } catch (err) {
      console.error("Download fetch error:", err);
      setError("Error fetching download data");
    } finally {
      setDownloadLoading(false);
    }
  };

  const handleFetchReports = () => {
    if (!downloadMonth) {
      alert("Please select a month first");
      return;
    }
    fetchDownloadData(downloadMonth, selectedReport);
  };

  // ── Close selected month ───────────────────────────────────────────────
  const handleUpdate = async () => {
    if (!closeMonth) {
      alert("Please select a month first");
      return;
    }

    const confirmClose = window.confirm(
      `Are you sure you want to close reports for ${closeMonth}?`
    );
    if (!confirmClose) return;

    const formattedDate = getFormattedDate();
    const updatedFormData = {
      is_active: 0
    };

    const payload = {
      schema_name: "irn",
      table: "irn_report",
      set_column: updatedFormData,
      where: [{ month: closeMonth}],
    };

    setCloseLoading(true);
    try {
      const creds = Fetchupdatequery();
      await axios.post(creds[1], payload, creds[0]);
      setCloseMsg(`✓ Reports closed for ${closeMonth}`);
      setTimeout(() => setCloseMsg(""), 4000);
      setCloseMonth("");
      if (downloadMonth === closeMonth) {
        setDownloadData([]);
        setDownloadColumns([]);
      }
      await fetchHistory();
    } catch (err) {
      console.error("Error updating data:", err);
      setError("Error updating data");
    } finally {
      setCloseLoading(false);
    }
  };

  // ── Export to Excel ──────────────────────────────────────────────────────
  const getExcelColumnName = (index) => {
    let column = "";
    let current = index;

    while (current > 0) {
      const remainder = (current - 1) % 26;
      column = String.fromCharCode(65 + remainder) + column;
      current = Math.floor((current - 1) / 26);
    }

    return column;
  };

  const getColumnIndex = (field) =>
    downloadColumns.findIndex((col) => col.field === field) + 1;

  const getCellRef = (field, rowNumber) => {
    const columnIndex = getColumnIndex(field);
    if (columnIndex <= 0) return "";
    return `${getExcelColumnName(columnIndex)}${rowNumber}`;
  };

  const getFormulaValue = (field, rowNumber) => {
    const formulas = {
      val_from_state: `=IF(${getCellRef("irn_from_state", rowNumber)}=${getCellRef("src_from_state", rowNumber)},TRUE,FALSE)`,
      val_to_state: `=IF(${getCellRef("irn_to_state", rowNumber)}=${getCellRef("src_to_state", rowNumber)},TRUE,FALSE)`,
      val_gst: `=IF(TRIM(${getCellRef("irn_gst", rowNumber)})=TRIM(${getCellRef("src_gst", rowNumber)}),TRUE,FALSE)`,
      diff_taxable: `=IFERROR(${getCellRef("irn_taxable", rowNumber)}-${getCellRef("src_taxable", rowNumber)},0)`,
      diff_cgst: `=IFERROR(${getCellRef("irn_cgst", rowNumber)}-${getCellRef("src_cgst", rowNumber)},0)`,
      diff_sgst: `=IFERROR(${getCellRef("irn_sgst", rowNumber)}-${getCellRef("src_sgst", rowNumber)},0)`,
      diff_igst: `=IFERROR(${getCellRef("irn_igst", rowNumber)}-${getCellRef("src_igst", rowNumber)},0)`,
      diff_total: `=IFERROR(${getCellRef("irn_total", rowNumber)}-${getCellRef("src_total", rowNumber)},0)`,
      val_hsn: `=IF(${getCellRef("irn_hsn", rowNumber)}=${getCellRef("src_hsn", rowNumber)},TRUE,FALSE)`,
      val_supply_type: `=IF(${getCellRef("irn_supply_type", rowNumber)}=${getCellRef("src_supply_type", rowNumber)},TRUE,FALSE)`,
      val_doc_type: `=IF(${getCellRef("irn_doc_type", rowNumber)}=${getCellRef("src_doc_type", rowNumber)},TRUE,FALSE)`,
      val_date: `=${getCellRef("irn_date", rowNumber)}=${getCellRef("src_date", rowNumber)}`,
    };

    return formulas[field] || null;
  };

  const exportIrnToExcel = async () => {
    if (!downloadData || downloadData.length === 0) {
      alert("No data to export");
      return;
    }

    setExportLoading(true);
    try {
      const headers = downloadColumns.map(col => `"${col.headerName}"`).join(",");
      const rows = downloadData.map((row, rowIndex) => {
        const excelRowNumber = rowIndex + 2;

        return downloadColumns.map((col) => {
          const formulaValue = getFormulaValue(col.field, excelRowNumber);
          const value = formulaValue ?? row[col.field];
          return `"${String(value ?? "").replace(/"/g, '""')}"`;
        }).join(",");
      });

      const csv = [headers, ...rows].join("\n");
      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `IRN_Report_${downloadMonth || new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } finally {
      setExportLoading(false);
    }
  };

  const exportSalesRegisterToExcel = async () => {
    if (!salesRegisterData || Object.keys(salesRegisterData).length === 0) {
      alert("No data to export");
      return;
    }

    setExportLoading(true);
    try {
      const workbook = XLSX.utils.book_new();
      let hasData = false;

      SALES_SHEETS.forEach((sheet) => {
        const data = salesRegisterData[sheet.value];
        
        // Ensure data is an array and has items
        if (Array.isArray(data) && data.length > 0) {
          hasData = true;
          
          const allKeys = Object.keys(data[0]);
          
          // Build worksheet data with header and rows
          const worksheetData = [
            allKeys.map(key => 
              key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
            )
          ];

          // Add all data rows
          data.forEach((row) => {
            worksheetData.push(allKeys.map(key => row[key] ?? ''));
          });

          // Create worksheet from array of arrays
          const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

          // Now add formulas by updating specific cells
          data.forEach((row, rowIndex) => {
            const excelRowNumber = rowIndex + 2; // Excel row starts at 2 (1 is header)
            
            allKeys.forEach((key, colIndex) => {
              const cellRef = XLSX.utils.encode_cell({ r: rowIndex + 1, c: colIndex });
              const formulaValue = getFormulaValueForSalesRegister(key, excelRowNumber, allKeys);
              
              if (formulaValue) {
                // Set formula cell with proper structure
                worksheet[cellRef] = { 
                  f: formulaValue,
                  t: "f"  // Mark as formula type
                };
              }
            });
          });

          // Set worksheet dimensions
          worksheet['!ref'] = XLSX.utils.encode_range({
            s: { r: 0, c: 0 },
            e: { r: data.length, c: allKeys.length - 1 }
          });

          XLSX.utils.book_append_sheet(workbook, worksheet, sheet.label);
        }
      });

      if (!hasData) {
        alert("No data available in any sheet to export");
        setExportLoading(false);
        return;
      }

      XLSX.writeFile(
        workbook,
        `Sales_Register_${downloadMonth || new Date().toISOString().slice(0, 10)}.xlsx`
      );
    } catch (err) {
      console.error("Export error:", err);
      setError("Error exporting to Excel");
    } finally {
      setExportLoading(false);
    }
  };

  const getFormulaValueForSalesRegister = (field, rowNumber, allKeys) => {
    // Get column indices for formula fields - case insensitive search
    const getColLetter = (fieldName) => {
      const idx = allKeys.findIndex(key => 
        key.toLowerCase() === fieldName.toLowerCase()
      );
      if (idx >= 0) {
        return XLSX.utils.encode_col(idx);
      }
      return null;
    };

    // Map formula fields to actual database columns from all 3 sheets
    // These names come from: SELECT dn.*, SELECT cn.*, SELECT ti.*
    const colMap = {
      irn_from_state: getColLetter('irn_from_state'),
      src_from_state: getColLetter('Invoice From State') || getColLetter('from state code'),
      irn_to_state: getColLetter('irn_to_state'),
      src_to_state: getColLetter('Invoice To State') || getColLetter('to state code'),
      irn_gst: getColLetter('irn_gst'),
      src_gst: getColLetter('Client_GST_No') || getColLetter('client gst no'),
      irn_taxable: getColLetter('irn_taxable'),
      src_taxable: getColLetter('Taxable') || getColLetter('taxable'),
      irn_cgst: getColLetter('irn_cgst'),
      src_cgst: getColLetter('CGST@9%') || getColLetter('cgst'),
      irn_sgst: getColLetter('irn_sgst'),
      src_sgst: getColLetter('SGST/UTGST@9%') || getColLetter('sgst/ugst'),
      irn_igst: getColLetter('irn_igst'),
      src_igst: getColLetter('IGST@18%') || getColLetter('igst'),
      irn_total: getColLetter('irn_total'),
      src_total: getColLetter('Debit Note Total') || getColLetter('invoice total'),
      irn_hsn: getColLetter('irn_hsn'),
      src_hsn: getColLetter('HSN_Code') || getColLetter('hsn/sac code'),
      irn_supply_type: getColLetter('irn_supply_type'),
      src_supply_type: getColLetter('supply_type_code'),
      irn_doc_type: getColLetter('irn_doc_type'),
      src_doc_type: getColLetter('invoice_type') || getColLetter('document_type'),
      irn_date: getColLetter('irn_date'),
      src_date: getColLetter('Date') || getColLetter('credit note date') || getColLetter('invoice date'),
    };

    const formulas = {
      val_from_state: colMap.irn_from_state && colMap.src_from_state 
        ? `=IF(${colMap.irn_from_state}${rowNumber}=${colMap.src_from_state}${rowNumber},TRUE,FALSE)`
        : null,
      val_to_state: colMap.irn_to_state && colMap.src_to_state
        ? `=IF(${colMap.irn_to_state}${rowNumber}=${colMap.src_to_state}${rowNumber},TRUE,FALSE)`
        : null,
      val_gst: colMap.irn_gst && colMap.src_gst
        ? `=IF(TRIM(${colMap.irn_gst}${rowNumber})=TRIM(${colMap.src_gst}${rowNumber}),TRUE,FALSE)`
        : null,
      diff_taxable: colMap.irn_taxable && colMap.src_taxable
        ? `=IFERROR(${colMap.irn_taxable}${rowNumber}-${colMap.src_taxable}${rowNumber},0)`
        : null,
      diff_cgst: colMap.irn_cgst && colMap.src_cgst
        ? `=IFERROR(${colMap.irn_cgst}${rowNumber}-${colMap.src_cgst}${rowNumber},0)`
        : null,
      diff_sgst: colMap.irn_sgst && colMap.src_sgst
        ? `=IFERROR(${colMap.irn_sgst}${rowNumber}-${colMap.src_sgst}${rowNumber},0)`
        : null,
      diff_igst: colMap.irn_igst && colMap.src_igst
        ? `=IFERROR(${colMap.irn_igst}${rowNumber}-${colMap.src_igst}${rowNumber},0)`
        : null,
      diff_total: colMap.irn_total && colMap.src_total
        ? `=IFERROR(${colMap.irn_total}${rowNumber}-${colMap.src_total}${rowNumber},0)`
        : null,
      val_hsn: colMap.irn_hsn && colMap.src_hsn
        ? `=IF(${colMap.irn_hsn}${rowNumber}=${colMap.src_hsn}${rowNumber},TRUE,FALSE)`
        : null,
      val_supply_type: colMap.irn_supply_type && colMap.src_supply_type
        ? `=IF(${colMap.irn_supply_type}${rowNumber}=${colMap.src_supply_type}${rowNumber},TRUE,FALSE)`
        : null,
      val_doc_type: colMap.irn_doc_type && colMap.src_doc_type
        ? `=IF(${colMap.irn_doc_type}${rowNumber}=${colMap.src_doc_type}${rowNumber},TRUE,FALSE)`
        : null,
      val_date: colMap.irn_date && colMap.src_date
        ? `=IF(${colMap.irn_date}${rowNumber}=${colMap.src_date}${rowNumber},TRUE,FALSE)`
        : null,
    };

    // Debug log for first row of first sheet
    if (rowNumber === 2) {
      console.log(`Formula for field "${field}" at row ${rowNumber}:`, formulas[field]);
      if (formulas[field]) {
        console.log(`Column mapping for ${field}:`, colMap);
      }
    }

    return formulas[field] || null;
  };

  const exportToExcel = async () => {
    if (selectedReport === "sales_register") {
      await exportSalesRegisterToExcel();
    } else {
      await exportIrnToExcel();
    }
  };

  useEffect(() => {
    const init = async () => {
      await fetchHistory();
      setLoading(false);
    };
    init();
  }, []);

  // ── Submit to backend ─────────────────────────────────────────────────────
  const handleUpload = async () => {
    if (!fileUploads.file?.filePath) {
      alert("Please choose a file first.");
      return;
    }
    if (!selectedMonth) {
      alert("Please select a month before uploading.");
      return;
    }
    if (!selectedReport) {
      alert("Please select a report type before uploading.");
      return;
    }

    const reportConfig  = REPORT_OPTIONS.find((o) => o.value === selectedReport);
    const formattedDate = getFormattedDate();

    const fd = new FormData();
    fd.append("file_name",       fileUploads.file.fileName);
    fd.append("file_path",       fileUploads.file.filePath);
    fd.append("source_name",     reportConfig.value);
    fd.append("source_type",     reportConfig.label);
    if (reportConfig.table) fd.append("table", reportConfig.table);
    fd.append("month",           selectedMonth);
    fd.append("last_updated_on", formattedDate);
    fd.append("modified_by",     userCredentials.user_id);
    fd.append("last_updated_by", userCredentials.user_name);
    fd.append("config_id",       219);
    fd.append("tenants_id",      userCredentials.tenants_id);
    fd.append("groups_id",       userCredentials.groups_id);
    fd.append("entities_id",     userCredentials.selectedentity);
    fd.append("user_id",         userCredentials.user_id);
    fd.append("process_id",      36);
    fd.append("skiprows",        0);

    setUploadLoading(true);
    try {
      const creds = Fetchetlupload();
      await axios.post(creds[1], fd, {
        ...creds[0],
        headers: { ...creds[0]?.headers, "Content-Type": "multipart/form-data" },
      });

      // ── success: reset first, then show message ──
      resetForm();
      await fetchHistory();
      setSuccessMsg("✓ File uploaded successfully!");
      setTimeout(() => setSuccessMsg(""), 4000); // auto-hide after 4s

    } catch (err) {
      console.error(err);
      setError("Upload failed");
    } finally {
      setUploadLoading(false);
    }
  };

  return (
    <div>
      <h2 style={{ textAlign: "center", color: "#4969ab" }}>
        IRN Management
      </h2>

      {/* ── Status messages ── */}
      {error      && <div style={{ color: "red",   marginBottom: "6px" }}>{error}</div>}
      {closeMsg   && <div style={{ color: "green", marginBottom: "6px" }}>{closeMsg}</div>}
      {successMsg && (
        <div style={{
          color:        "green",
          marginBottom: "6px",
          fontWeight:   600,
          fontSize:     "14px",
          padding:      "8px 12px",
          background:   "#f0fff4",
          borderRadius: "6px",
          border:       "1px solid #b7ebc0",
        }}>
          {successMsg}
        </div>
      )}

      {/* ── Tabs ── */}
      <Tabs selectedIndex={activeTab} onSelect={setActiveTab}>
        <TabList>
          <Tab>File Upload</Tab>
          <Tab>Report Download</Tab>
          <Tab>Closing</Tab>
        </TabList>

        <TabPanel>
          <div
            style={{
              display:      "flex",
              flexWrap:     "wrap",
              gap:          "16px",
              alignItems:   "flex-end",
              padding:      "10px 14px",
              background:   "#f5f7fb",
              borderRadius: "8px",
              border:       "1px solid #e0e4ef",
              margin:       "10px 0",
            }}
          >
            {/* File input */}
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label style={{ fontWeight: 600, fontSize: "13px", color: "#4969ab" }}>
                File Name
              </label>
              <input
                key={fileInputKey}
                ref={fileInputRef}
                type="file"
                accept=".xlsx,.xls,.xlsb,.csv"
                onChange={(e) => handleFileUpload(e, "file", FILE_UPLOAD_PATH)}
                style={{
                  padding:      "5px 8px",
                  borderRadius: "6px",
                  border:       "1px solid #ccc",
                  fontSize:     "13px",
                  background:   "#fff",
                  cursor:       "pointer",
                }}
              />
              {fileUploads.file?.fileName && (
                <span style={{ fontSize: "11px", color: "green" }}>
                  ✓ {fileUploads.file.fileName}
                </span>
              )}
            </div>

            {/* Month */}
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label style={{ fontWeight: 600, fontSize: "13px", color: "#4969ab" }}>
                Month <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="month"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                style={{
                  padding:      "7px 10px",
                  borderRadius: "6px",
                  border:       "1px solid #ccc",
                  fontSize:     "14px",
                  minWidth:     "160px",
                }}
              />
            </div>

            {/* Report type */}
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label style={{ fontWeight: 600, fontSize: "13px", color: "#4969ab" }}>
                Report Type <span style={{ color: "red" }}>*</span>
              </label>
              <select
                value={selectedReport}
                onChange={(e) => setSelectedReport(e.target.value)}
                style={{
                  padding:      "7px 10px",
                  borderRadius: "6px",
                  border:       "1px solid #ccc",
                  fontSize:     "14px",
                  minWidth:     "180px",
                  background:   "#fff",
                }}
              >
                <option value="">-- Select Report Type --</option>
                {REPORT_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>

            {/* Upload button */}
            <button
              className="submit-btn"
              onClick={handleUpload}
              style={{ alignSelf: "flex-end", padding: "8px 16px" }}
            >
            Upload
            </button>
          </div>

          {/* History grid */}
          <div style={{ marginTop: "16px" }}>
            <h3 style={{ color: "#4969ab", marginBottom: "8px" }}>Upload History</h3>
            <div className="ag-theme-alpine" style={{ height: "400px", width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                pagination={true}
                paginationPageSize={10}
              />
            </div>
          </div>
        </TabPanel>

        {/* ── TAB 2: Report Download ── */}
        <TabPanel>
          {/* Toolbar row */}
          <div
            style={{
              display:      "flex",
              flexWrap:     "wrap",
              gap:          "16px",
              alignItems:   "flex-end",
              padding:      "10px 14px",
              background:   "#f5f7fb",
              borderRadius: "8px",
              border:       "1px solid #e0e4ef",
              margin:       "10px 0",
            }}
          >
            {/* Month selector */}
             <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label style={{ fontWeight: 600, fontSize: "13px", color: "#4969ab" }}>
                Report Type <span style={{ color: "red" }}>*</span>
              </label>
              <select
                value={selectedReport}
                onChange={(e) => {
                  setSelectedReport(e.target.value);
                  setDownloadData([]);
                  setDownloadColumns([]);
                  setSalesRegisterData({});
                  setSalesRegisterColumns({});
                }}
                style={{
                  padding:      "7px 10px",
                  borderRadius: "6px",
                  border:       "1px solid #ccc",
                  fontSize:     "14px",
                  minWidth:     "180px",
                  background:   "#fff",
                }}
              >
                <option value="">-- Select Report Type --</option>
                {REPORT_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
            
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label style={{ fontWeight: 600, fontSize: "13px", color: "#4969ab" }}>
                Month <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="month"
                value={downloadMonth}
                onChange={(e) => setDownloadMonth(e.target.value)}
                style={{
                  padding:      "7px 10px",
                  borderRadius: "6px",
                  border:       "1px solid #ccc",
                  fontSize:     "14px",
                  minWidth:     "160px",
                }}
              />
            </div>

            {/* Fetch button */}
            <button
              className="submit-btn"
              onClick={handleFetchReports}
              disabled={downloadLoading}
              style={{ 
                alignSelf: "flex-end",
                margin: 0,
                position: "relative",
                top: "4px",
                opacity: downloadLoading ? 0.6 : 1,
                cursor: downloadLoading ? "not-allowed" : "pointer"
              }}

            >
              {downloadLoading ? "Fetching..." : "Fetch Reports"}
            </button>

            {/* Export icon - Show for both IRN and Sales Register */}
            {(
              (selectedReport === "irn_report" && downloadData.length > 0) ||
              (selectedReport === "sales_register" && Object.keys(salesRegisterData).some(key => salesRegisterData[key]?.length > 0))
            ) && (
              <img
                src={excelIcon}
                alt="Export to Excel"
                title="Export to Excel"
                onClick={exportToExcel}
                style={{
                  alignSelf: "flex-end",
                  width: "40px",
                  height: "37px",
                  marginTop: "4px",
                  cursor: "pointer",
                }}
              />
            )}
          </div>

          {/* IRN Report Grid */}
          {selectedReport === "irn_report" && (
            <div style={{ marginTop: "16px" }}>
              <p style={{ color: "#666", fontSize: "13px", marginBottom: "12px" }}>
                {downloadMonth ? `` : "Select a month to view available reports"}
              </p>
              <div className="ag-theme-alpine" style={{ height: "400px", width: "100%" }}>
                <AgGridReact
                  rowData={downloadData}
                  columnDefs={downloadColumns}
                  pagination={true}
                  paginationPageSize={10}
                />
              </div>
            </div>
          )}

          {/* Sales Register Tabs */}
          {selectedReport === "sales_register" && (
            <div style={{ marginTop: "16px" }}>
              <Tabs selectedIndex={activeSheetTab} onSelect={setActiveSheetTab}>
                <TabList>
                  {SALES_SHEETS.map((sheet) => (
                    <Tab key={sheet.value}>{sheet.label}</Tab>
                  ))}
                </TabList>

                {SALES_SHEETS.map((sheet) => (
                  <TabPanel key={sheet.value}>
                    <div className="ag-theme-alpine" style={{ height: "400px", width: "100%" }}>
                      {(salesRegisterData[sheet.value]?.length ?? 0) > 0 ? (
                        <AgGridReact
                          rowData={salesRegisterData[sheet.value]}
                          columnDefs={salesRegisterColumns[sheet.value]}
                          pagination={true}
                          paginationPageSize={10}
                        />
                      ) : (
                        <p style={{ padding: "20px", textAlign: "center", color: "#999" }}>
                          No data available for {sheet.label}
                        </p>
                      )}
                    </div>
                  </TabPanel>
                ))}
              </Tabs>
            </div>
          )}
        </TabPanel>

        {/* ── TAB 3: Closing ── */}
        <TabPanel>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
              alignItems: "flex-end",
              padding: "10px 14px",
              background: "#f5f7fb",
              borderRadius: "8px",
              border: "1px solid #e0e4ef",
              margin: "10px 0",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label style={{ fontWeight: 600, fontSize: "13px", color: "#4969ab" }}>
                Month <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="month"
                value={closeMonth}
                onChange={(e) => setCloseMonth(e.target.value)}
                style={{
                  padding: "7px 10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  fontSize: "14px",
                  minWidth: "160px",
                }}
              />
            </div>

            <button
              className="submit-btn"
              onClick={handleUpdate}
              disabled={closeLoading}
              style={{
                alignSelf: "flex-end",
                margin: 0,
                position: "relative",
                top: "4px",
                opacity: closeLoading ? 0.6 : 1,
                cursor: closeLoading ? "not-allowed" : "pointer",
              }}
            >
              {closeLoading ? "Closing..." : "Close Reports"}
            </button>
          </div>
        </TabPanel>

      </Tabs>

      {(loading || uploadLoading || downloadLoading || exportLoading) && (
        <LoaderComponent loaderOpen={true} />
      )}
    </div>
  );
}

export default IrnUpload;
